import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import {
  useGetCurrentClub,
  useHomeGamesWidget,
  useIsMobileDevice,
  useWidgetTheme
} from '@swf/poker';

import type { CreateModalLocationState } from '../../types/common';
import Header from '../Modal/Header/Header';

import styles from './CreateTournament.scss';
import CreateTournamentBanner from './CreateTournamentBanner/CreateTournamentBanner';
import type { TournamentContextState } from './CreateTournamentContext/CreateTournamentContext';
import CreateTournamentContext from './CreateTournamentContext/CreateTournamentContext';
import QuickCreateTournament from './QuickCreateTournament';

interface SearchParams extends CreateModalLocationState {
  clubId: number;
  widgetId?: string;
}

const CreateTournament: React.FC = () => {
  const { clubId, widgetId } = useSearchParams<SearchParams>();
  const club = useGetCurrentClub(`${clubId}`, widgetId);
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget(widgetId);
  const cashGames = useSelector(widgetSelect.tables);
  const tourns = useSelector(widgetSelect.tournaments);
  const noGames = isEmpty(cashGames) && isEmpty(tourns);

  const isMobileDevice = useIsMobileDevice(true);
  const [state, setState] = useState<TournamentContextState>({
    activePage: 0,
    ...club,
    isRecurrenceOpen: false,
    isAdvancedOptionsOpen: false,
    title: '',
    subTitle: '',
    widgetId,
    widgetSelect,
    widgetDispatch,
    loading: false,
    noGames
  });
  const { title, subTitle } = state;
  const { setStyle } = useContext(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.createTournModal,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <CreateTournamentContext.Provider value={{ state, setState }}>
      <div className={styles.container}>
        {!isMobileDevice && <CreateTournamentBanner />}
        <div className={styles.content}>
          <Header title={title} subTitle={subTitle} />
          <Body className={classNames(styles.body, styles.quickCreate)}>
            <QuickCreateTournament />
          </Body>
        </div>
      </div>
    </CreateTournamentContext.Provider>
  );
};

export default CreateTournament;
